async function init() {
  const lsPrefersOldBrowser = localStorage.getItem('prefersOldBrowser') === 'true';
  const urlParams = new URLSearchParams(window.location.search);
  const urlParamOverridePrefersOldBrowser = urlParams.get('prefersOldBrowser') === 'true';

  if (!lsPrefersOldBrowser && !urlParamOverridePrefersOldBrowser) {
    localStorage.setItem('prefersOldBrowser', 'false');

    const { ConsoleLogger } = await import('@nx/logger');
    const { frameworkInit } = await import('@nx/ui');

    const { MinimalBasicQueryWrapper } = await import('./shared/components/query-wrapper');
    const { QueryApp } = await import('./nx-entry/nx-view');

    void frameworkInit(
      <MinimalBasicQueryWrapper>
        <QueryApp />
      </MinimalBasicQueryWrapper>,
      {
        appManifest: {
          name: 'query',
          version: import.meta.env.VITE_APP_VERSION,
        },
        logger: new ConsoleLogger('query'),
        configuration: {
          windowTitle: 'Neo4j Browser',
          basePath: '/',
          fallbackRoute: '/',
          ssoRedirectPath: '/',
          tools: {
            query: {
              displayName: 'Query',
              route: '/',
            },
          },
          sentry: {
            dsn: import.meta.env.VITE_SENTRY_DSN,
            appVersion: import.meta.env.VITE_APP_VERSION,
          },
          segment: {
            apiKey: import.meta.env.VITE_SEGMENT_API_KEY,
            eventPrefix: 'QRY',
          },
        },
        capabilities: {
          'framework:connection-bar': true,
          'framework:connection-bar-show-version': true,
          'framework:connection-history': true,
          'framework:http-query-api': true,
          'framework:respect-dbms-neo4j-conf-settings': true,
          'framework:sso-db-connection': true,
          'framework:theme-switcher': true,
          'framework:filter-sentry-events-on-error-boundary': true,
          'framework:open-modal-on-missing-connection': true,
          'framework:discovery-api': true,
          'query:custom-guides': true,
          'query:enabled': true,
          'query:settings-on-sidebar': true,
          'query:offline-guides': true,
          'query:bundled': true,
          'query:welcome-frame': true,
          'query:community-punch-out': true,
        },
      },
    );
  }
}

void init();
